import { Injectable } from "@angular/core";
import { AbstractTransformerService } from "../abstract-transformer.service";
import { BehaviorSubject, Observable } from "rxjs";
import { ColumnTypes } from "../../data-grid/data-grid.component";

@Injectable({ providedIn: "root" })
export class SentenceChunkService extends AbstractTransformerService {
  private _columnTypes$ = new BehaviorSubject<ColumnTypes | null>(null);
  private _columnId$ = new BehaviorSubject<string | null>(null);
  private _sentencesPerChunk$ = new BehaviorSubject<number>(5);

  public get columnTypes$(): Observable<ColumnTypes | null> {
    return this._columnTypes$.asObservable();
  }
  public get columnId$(): Observable<string | null> {
    return this._columnId$.asObservable();
  }
  public get sentencesPerChunk$(): Observable<number> {
    return this._sentencesPerChunk$.asObservable();
  }

  public get columnTypes(): ColumnTypes | null {
    return this._columnTypes$.getValue();
  }
  public set columnTypes(types: ColumnTypes | null) {
    this._columnTypes$.next(types);
  }

  public get columnId(): string | null {
    return this._columnId$.getValue();
  }
  public set columnId(id: string | null) {
    this._columnId$.next(id);
  }

  public get sentencesPerChunk(): number {
    return this._sentencesPerChunk$.getValue();
  }
  public set sentencesPerChunk(s: number) {
    this._sentencesPerChunk$.next(s);
  }

  override reset() {
    super.reset();
    this.columnId = null;
    this.sentencesPerChunk = 5;
  }
}
